import type { ApiVolopId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiUnpublishedVolop } from './types/ApiUnpublishedVolop';
import type { ApiVolop } from './types/ApiVolop';

type ApiResponse = {
  data: ApiVolop | ApiUnpublishedVolop;
};

function mapResponse(response: ApiResponse): ApiVolop | ApiUnpublishedVolop {
  return response.data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (volopId: ApiVolopId) => `/data/website/volops/${volopId}`,
  mapResponse,
});

// Exports

export const listingApiIsomorphicFetchVolop =
  endpoint.createIsomorphicFetchFn();
